import initialsOf from '@UI/Helpers/initialsOf';

const FALLBACK_INITIALS = 'D';

/** The two letters an `IdentityTile` carries for a dossier: the first letters of the first two words of its title. */
const buildSubjectInitials = (title: string | null): string => {
	const [firstWord, secondWord] = (title ?? '').split(/\s+/);

	return initialsOf(firstWord ?? '', secondWord ?? '') || FALLBACK_INITIALS;
};

export default buildSubjectInitials;
